<template>
    <div class="itinerario">
        <RightPanel title="Itinerario">
            <template>
                <div class="timeline" >
                    <div class="timeline-item" v-for="(item, index) in days" :key="index">
                        <ItemDay :value="item.day"/>
                        <ItemVoloAndata v-if="index===0"/>
                        <ItemTransferNight :day="item.day"/>
                        <ItemVoloAndata v-if="index===1" :is-destinazione="true" :day="item.day"/>
                        <!-- trasferimento andata index <=1 !-->
                        <ItemService :is-trasferimento="true" v-if="index <= 1" :day="item.day" @detail="onServiceDetail" @delete="onServiceDelete" />
                        <ItemHotelCheckOut :day="item.day" :days="days" @detail="onHotelDetail"/>
                        <ItemMinitourDay v-if="hasTour" :day="item.day"/>
                        <ItemHotelCheckIn :day="item.day" :days="days" @detail="onHotelDetail"/>
                        <ItemService v-if="index === days.length - 1" :day="item.day" @detail="onServiceDetail" />
                        <!-- trasferimento ritorno index = days.length -1 -->
                        <ItemService :is-trasferimento="true" v-if="index === days.length - 1" :day="item.day" @detail="onServiceDetail"/>
                        <ItemVoloRitorno v-if="index===days.length-1"/>
                        <ItemService v-if="index < days.length - 1" :day="item.day" @detail="onServiceDetail"/>
                    </div>
                    <div v-if="isPlusDay" class="timeline-item">
                        <ItemDay :value="dayAdded"/>
                        <ItemVoloRitorno :is-destinazione="true"/>
                    </div>
                </div>
            </template>
        </RightPanel>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import RightPanel from '../../../templates/RightPanel'
import ItemVoloAndata from '../../common/itinerario/ItemVoloAndata'
import ItemDay from '../../common/itinerario/ItemDay'
import ItemVoloRitorno from '../../common/itinerario/ItemVoloRitorno'
import ItemHotelCheckIn from '../../common/itinerario/ItemHotelCheckIn'
import ItemHotelCheckOut from '../../common/itinerario/ItemHotelCheckOut'
import ItemService from '../../common/itinerario/ItemService'
import {toDateFromServer} from '../../../../utils/formatter'
import {isSameDate} from '../../../../utils/helper'
import ItemMinitourDay from '../../common/itinerario/ItemMinitourDay'
import AnalyticEvents from '../../../common/AnalyticEvents'
import ItemTransferNight from '../../common/itinerario/ItemTransferNight'

export default {
  name: 'Itinerario',
  mixins: [AnalyticEvents],
  components: {ItemTransferNight, ItemMinitourDay, ItemService, ItemHotelCheckIn, ItemHotelCheckOut, ItemVoloRitorno, ItemDay, ItemVoloAndata, RightPanel},
  computed: {
    days () {
      return this.getItinerario().days
    },
    dayAdded () {
      const length = this.flight.voli.length
      return toDateFromServer(this.flight.voli[length - 1].destinazione.dataOra.date.date)
    },
    isPlusDay () {
      const length = this.flight.voli.length
      const partenzaDate = toDateFromServer(this.flight.voli[0].partenza.dataOra.date.date)
      const destinazioneDate = toDateFromServer(this.flight.voli[length - 1].destinazione.dataOra.date.date)
      return !isSameDate(partenzaDate, destinazioneDate)
    },
    flight () {
      return this.getFlightTo()
    },
    hasTour () {
      return this.tour.detailResponses.length > 0
    },
    tour () {
      return this.getTour()
    }
  },
  methods: {
    ...mapGetters(['getItinerario', 'getTour', 'getFlightTo']),
    onServiceDetail (item) {
      this.trackSidebarInfo()
      this.$emit('service', item)
    },
    onServiceDelete () {
      this.trackSidebarElimina()
    },
    onHotelDetail (item) {
      this.trackSidebarInfo()
      this.$emit('hotel', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/Itinerario.vue